export type Vertex = [number, number];

export function pointsInPolygon(
  positions: Float32Array,
  polygon: Vertex[]
): Uint32Array {
  const m = polygon.length;
  if (m < 3) return new Uint32Array(0);

  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;
  for (let k = 0; k < m; k++) {
    const x = polygon[k][0];
    const y = polygon[k][1];
    if (x < minX) minX = x;
    if (x > maxX) maxX = x;
    if (y < minY) minY = y;
    if (y > maxY) maxY = y;
  }

  const n = positions.length / 2;
  const out = new Uint32Array(n);
  let count = 0;

  for (let i = 0; i < n; i++) {
    const x = positions[i * 2];
    const y = positions[i * 2 + 1];
    if (x < minX || x > maxX || y < minY || y > maxY) continue;

    let inside = false;
    let j = m - 1;
    for (let k = 0; k < m; k++) {
      const xk = polygon[k][0];
      const yk = polygon[k][1];
      const xj = polygon[j][0];
      const yj = polygon[j][1];
      if (yk > y !== yj > y && x < ((xj - xk) * (y - yk)) / (yj - yk) + xk) {
        inside = !inside;
      }
      j = k;
    }
    if (inside) {
      out[count++] = i;
    }
  }

  return out.slice(0, count);
}
